// Styled confirmation modal (new design system). Driven by the useConfirm hook.
export default function ConfirmModal({
  open,
  title = "Are you sure?",
  message = "",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  danger = true,
  onConfirm = () => {},
  onCancel = () => {},
}) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 380 }}>
        <div className="confirm-icon" aria-hidden="true">
          <svg><use href={`#i-${danger ? "trash" : "warn"}`} /></svg>
        </div>
        <h3>{title}</h3>
        {message ? <p className="confirm-msg">{message}</p> : null}
        <div className="modal-actions" style={{ justifyContent: "center" }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel}>{cancelLabel}</button>
          <button type="button" className={`btn ${danger ? "btn-danger" : "btn-primary"}`} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
